var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_659",
    "data-name": "Group 659",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.262,
    height: 51.261,
    viewBox: "0 0 51.262 51.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M25.63,0A25.63,25.63,0,1,1,0,25.63,25.63,25.63,0,0,1,25.63,0Z",
    fill: "#0b2a46",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M14.122,10.883,20.9,3H19.3L13.408,9.845,8.7,3H3.28l7.112,10.351L3.28,21.618H4.887l6.219-7.229,4.967,7.229H21.5L14.121,10.883h0Zm-2.2,2.559-.72-1.03L5.466,4.21H7.935l4.627,6.619.72,1.03,6.015,8.6H16.829l-4.908-7.021h0Z",
    transform: "translate(13.19 13.47)",
    fill: "#e4e4e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.915d40b5c87b48fc45510308487106d1.svg";
export { ForwardRef as ReactComponent };